import { __awaiter, __generator, __read, __spread } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: {
    wallet: null,
    walletDetail: {
      list: [],
      loaded: false,
      requesting: false
    }
  },
  mutations: {
    /**
     * 记录wallet数据
     */
    setWallet: function setWallet(state, wallet) {
      state.wallet = wallet;
    },

    /**
     * 记录余额明细
     */
    concatWalletDetail: function concatWalletDetail(state, list) {
      var _a;

      (_a = state.walletDetail.list).push.apply(_a, __spread(list));
    },

    /**
     * 记录余额全部加载
     */
    setWalletDetailLoaded: function setWalletDetailLoaded(state, loaded) {
      state.walletDetail.loaded = loaded;
    },

    /**
     * 记录余额正在请求
     */
    setWalletDetailReq: function setWalletDetailReq(state, req) {
      state.walletDetail.requesting = req;
    }
  },
  actions: {
    /**
     * 获得余额
     */
    getWallet: function getWallet(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/wallet')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setWallet', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取余额明细
     */
    getWalletDetail: function getWalletDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, length, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.walletDetail;

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              length = wrap.list.length;

              if (end <= length) {
                return [2
                /*return*/
                ];
              }

              if (offset < length) {
                offset = length;
                count = end - offset;
              }

              commit('setWalletDetailReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/wallet_detail', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatWalletDetail', list);

                if (list.length < count) {
                  commit('setWalletDetailLoaded', true);
                }
              }

              commit('setWalletDetailReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 钱包余额提现
     */
    walletWithdraw: function walletWithdraw(_a, _b) {
      var dispatch = _a.dispatch;
      var money = _b.money;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/withdrawal', {
                params: {
                  money: money
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              if (!(rdata.status === 0)) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , dispatch('getWallet')];

            case 2:
              _c.sent();

              _c.label = 3;

            case 3:
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;